import { generateObjectHash } from './object-hash';
import {
  InverseIndexReferenceMap,
  InverseIndexValuesMap,
  InverseIndexDataMap,
  InverseIndexDataValuesMap,
  ListItem,
} from './types';

export class IndicesController {
  private indexMap: InverseIndexReferenceMap = new Map();
  // Possible performance gain*
  private dataMap: InverseIndexDataMap = new Map();

  constructor() {}

  public reset(attributeKey?: string): void {
    if (attributeKey) {
      this.indexMap.delete(attributeKey);
      this.dataMap.delete(attributeKey);
    } else {
      this.indexMap.clear();
      this.dataMap.clear();
    }
  }

  public fillDataMap(attributeKey: string, attributeValue: Array<string | undefined | ListItem>): void {
    let valueMap = this.dataMap.get(attributeKey);

    if (!valueMap) {
      valueMap = new Map();
      this.dataMap.set(attributeKey, valueMap);
    }

    for (const value of attributeValue) {
      let keyAsString!: any;
      if (typeof value === 'object' && value && value.key) {
        keyAsString = value.key;
      } else if (Array.isArray(value)) {
        for (const item of value) {
          this.fillDataMap(attributeKey, [item]);
        }
        return;
      } else {
        keyAsString = value;
      }

      let listItem = valueMap!.get(keyAsString);
      if (!listItem) {
        listItem = { key: keyAsString };
        this.dataMap.get(attributeKey)?.set(keyAsString, listItem);
      }
    }
  }

  public fillInverseIndex(
    attributeKey: string,
    originKey: string,
    foreignKeys: Array<string | undefined | ListItem>,
  ): void {
    if (!attributeKey || !originKey || !foreignKeys || !Array.isArray(foreignKeys)) {
      return;
    }

    const valueMap = this.indexMap.get(attributeKey) || new Map();

    for (const value of foreignKeys) {
      let keyAsString!: any;

      if (typeof value === 'object' && value && value.key) {
        keyAsString = value.key;
      } else if (Array.isArray(value)) {
        // keyAsString = JSON.stringify(value);
        for (const item of value) {
          this.fillInverseIndex(attributeKey, originKey, [item]);
        }
        return;
      } else {
        keyAsString = value;
      }

      const valueArray = valueMap.get(keyAsString) || [];
      valueArray.push(originKey);
      valueMap.set(keyAsString, valueArray);
    }
    this.indexMap.set(attributeKey, valueMap);
  }

  public getIndex(attributeKey: string, context?: any): InverseIndexValuesMap | undefined {
    const indexName = this.getIndexName(attributeKey, context);

    return this.indexMap.get(indexName);
  }

  public getData(attributeKey: string, context?: any): InverseIndexDataValuesMap | undefined {
    const indexName = this.getIndexName(attributeKey, context);
    return this.dataMap.get(indexName);
  }

  public getOrCreateIndex(
    attributeKey: string,
    relevantData: Map<string, ListItem>,
    context?: any,
  ): InverseIndexValuesMap {
    const indexName = this.getIndexName(attributeKey, context);

    let index = this.getIndex(indexName);

    if (!index) {
      this.reset(indexName);

      this.indexMap.set(indexName, new Map());

      for (const entry of relevantData.values()) {
        const attributeValue = entry[attributeKey];
        this.fillInverseIndex(indexName, entry.key, [attributeValue]);
        this.fillDataMap(indexName, [attributeValue]);
      }
      index = this.getIndex(indexName) || new Map();
    }
    return index!;
  }

  public getIndexName(attributeKey: string, context?: any): string {
    return context ? attributeKey + '_' + generateObjectHash(context) : attributeKey;
  }
}
